export namespace MainDataModels {

    export interface Mitarbeiter {
        userID: number;
        loginname: string;
        lastname: string;
        firstname: string;
        fK_EmployeeID: number;
        active: number;
        mandator: string;
        calendarcolor: number;
        calendarHexColor: string;
        defaultCalendarObject: string;
        defaultTaskObject: string;
        terminSaveino365: boolean;
        taskSaveino365: boolean;
        dashboardname: string;
        webLoginName: string;
    }

    export interface MitarbeiterGruppe {
        id: number;
        description: string;
    }

    export interface MitarbeiterGruppeZuord {
        id: number;
        userID: number;
    }


    // Die Kategorie wird vom Termin, der Aufgabe und der Notiz genutzt
    export interface Kategorie {
        id: number;
        mandantID: string;
        description: string;
        color?: number;
        topColor?: number;
        bottomColor?: number;
    }

    /* Start Termin */

    export interface TerminKategorieZuord {
        id: string;
        calenderID: string;
        categoryID?: number;
    }

    export interface TerminStatus {
        name: string;
        status: number;
    }

    export interface TerminErinnerung {
        id: number;
        name: string;
        reminder: number;
        minuten: number;
    }

    export interface KalenderDaten {
        termine: Termin[];
        terminSerien: TerminSerie[];
        terminSerieAusnahmen: TerminSerieAusnahme[];
    }

    export interface Termin {
        id: string;
        objectID: string;
        adressID?: string;
        contactID?: string;
        description: string;
        username: string;
        startDate?: Date;
        startTime?: string;
        endDate?: Date;
        endTime?: string;
        location: string;
        private: number;
        reminder: number;
        reminderNumber: number;
        storeInOL?: number;
        notes: string;
        groupID?: string;
        busyStatus: number;
        IsAllDay?: boolean;
        modifiedBy?: string;
        createdBy?: string;
    }

    export const EmptyTermin = (): Termin => ({
        id: '',
        objectID: '',
        adressID: undefined,
        contactID: undefined,
        description: '',
        username: '',
        startDate: undefined,
        startTime: undefined,
        endDate: undefined,
        endTime: undefined,
        location: '',
        private: 0,
        reminder: 1,
        reminderNumber: 15,
        storeInOL: 0,
        notes: '',
        groupID: undefined,
        busyStatus: 2,
        IsAllDay: false
    });

    export interface TerminSerie {
        calendarId: string;
        startDate?: Date;
        startTime?: string;
        endDate?: Date;
        endTime?: string;
        duration: number;
        durationType: number;
        recurrenceType: number;
        occurrences: number;
        ordinalDay: number;
        ordinalWeek: number;
        ordinalMonth: number;
        ordinalNumber: number;
        month: number;
        day: number;
        dayType: number;
    }

    export interface TerminSerieAusnahme {
        calendarID: string;
        type: number;
        originalDate: Date;
        exceptionCalID: string;
        username: string;
    }

    export interface TerminAdresse {
        adressID: string;
        adressNo: number;
        shortname: string;
        firstName: string;
        lastName: string;
        companyDescription: string;
        street1: string;
        street2: string;
        zip: string;
        city: string;
        phone01: string;
        phone02: string;
        phone03: string;
        phone04: string;
        email: string;
        homePage: string;
    }

    export const EmptyTerminAdresse = (): TerminAdresse => ({
        adressID: '', adressNo: 0, shortname: '', firstName: '', lastName: '', companyDescription: '', street1: '', street2: '', zip: '', city: '', phone01: '', phone02: '', phone03: '', phone04: '', email: '', homePage: ''
    });

    export interface TerminVerschiebung {
        Id: string;
        startDate?: Date;
        startTime?: string;
        endDate?: Date;
        endTime?: string;
    }

    export interface TerminMitBenutzer {
        termin: Termin;
        mitarbeiter: Mitarbeiter[];
        terminKategorien: TerminKategorieZuord[];
        istNeuerTermin: boolean;
        nurDiesenTerminBearbeiten: boolean;
    }

    export const EmptyTerminMitBenutzer = (): TerminMitBenutzer => ({
        termin: EmptyTermin(), mitarbeiter: [], terminKategorien: [], istNeuerTermin: true, nurDiesenTerminBearbeiten: true
    });

    export interface TerminListenEintrag {
        id: string;
        objectID: string;
        terminStart: Date;
        terminEnde: Date;
        objDesc: string;
        description: string;
        location: string;
        createdBy?: string;
        reminder?: number;
    }

    /* Ende Termin */


    /* Start Aufgabe */

    export interface AufgabeKategorieZuord {
        id: string;
        taskID: string;
        categoryID: number;
    }

    export interface Aufgabe {
        taskUID: string;
        objectID: string;
        adressID?: string;
        contactID?: string;
        responsible: string;
        description: string;
        dueDate?: Date;
        importance: number;
        done: boolean;
        maxTime?: number;
        percentDone: number;
        status: number;
        private: number;
        accepted: number;
        wasRead: number;
        reminder: number;
        reminderDate?: Date;
        reminderTime?: string;
        notes: string;
        startdate?: Date;
        createdBy?: string;
        modifiedBy?: string;
    }

    export const EmptyAufgabe = (): Aufgabe => ({
        taskUID: '',
        objectID: '',
        adressID: undefined,
        contactID: undefined,
        responsible: '',
        description: '',
        dueDate: undefined,
        importance: 1,
        done: false,
        maxTime: undefined,
        percentDone: 0,
        status: 0,
        private: 0,
        accepted: 1,
        wasRead: 1,
        reminder: 0,
        reminderDate: undefined,
        reminderTime: undefined,
        notes: '',
        startdate: undefined
    });

    export interface AufgabeMitBenutzer {
        aufgabe: Aufgabe;
        mitarbeiter: Mitarbeiter[];
        aufgabeKategorien: AufgabeKategorieZuord[];
        istNeueAufgabe: boolean;
    }

    export interface AufgabeWichtigkeit {
        id: number;
        name: string;
    }

    export const EmptyAufgabeMitBenutzer = (): AufgabeMitBenutzer => ({
        aufgabe: EmptyAufgabe(), mitarbeiter: [], aufgabeKategorien: [], istNeueAufgabe: true
    });

    /* Ende Aufgabe */


    /* Start Notizen */

    export interface NotizKategorieZuord {
        id: string;
        noteID: string;
        categoryID: number;
    }

    export interface Notiz {
        noteID: string;
        objectID: string;
        objDesc: string;
        adressID?: string;
        contactID?: string;
        responsible: string;
        created: Date;
        createdBy: string;
        modified: Date;
        modifiedBy: string;
        notes: string;
        description: string;
        done: number;
        private: boolean;
        wasRead: number;
    }

    export const EmptyNotiz = (): Notiz => ({
        noteID: '',
        objectID: '',
        objDesc: '',
        adressID: undefined,
        contactID: undefined,
        responsible: '',
        created: new Date(),
        createdBy: '',
        modified: new Date(),
        modifiedBy: '',
        notes: '',
        description: '',
        done: 0,
        private: false,
        wasRead: 0,
    });

    export interface NotizMitBenutzer {
        notiz: Notiz;
        mitarbeiter: Mitarbeiter[];
        notizKategorien: NotizKategorieZuord[];
        istNeueNotiz: boolean;
    }

    export const EmptyNotizMitBenutzer = (): NotizMitBenutzer => ({
        notiz: EmptyNotiz(), mitarbeiter: [], notizKategorien: [], istNeueNotiz: true
    });

    export interface NotizListenEintrag {
        id: string;
        objectID: string;
        objDesc: string;
        description: string;
        notes: string;
        created: Date;
        createdBy: string;
        modified: Date;
        modifiedBy: string;
        wasRead: number;
    }

    /* Ende Notizen */

    export interface ObjektAdresseSlim {
        id: string;
        adressID: string;
        contactID: string;
        zusammenfassung: string;
        typ: number;
    }

    export interface SearchFieldResponseObjekt {
        objectID?: string;
        beschreibung: string;
    }

    export interface ItemsResponseObjekt {
        objectID: string;
        objectNumber: string;
        objectType: number;
        description: string;
    }

    export interface ItemsResponseObjs {
        apiObjekte: Array<ItemsResponseObjekt>;
    }

    // lieferant array
    export interface Lieferant {
        supplierID: number;
        supplierShortName: string;
    }

    export interface Bestellung {
        orderHeaderID: string;
        orderNo: string;
        date: Date;
        currency: string;
        amount: number;
    }

    export interface BestellPosition {
        orderID: string;
        productNo: number;
        description: string;
        amount: number;
        unit: string;
        price: number;
        delivered: boolean;
        isSavedOnDb: boolean;
    }
}
